import en from "./translations/en.json";
import it from "./translations/it.json";

export const translations = { en, it };
